import React from 'react';

interface StatCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  color: string;
}

export const StatCard: React.FC<StatCardProps> = ({ title, value, icon, color }) => (
  <div className="bg-card-color-100 dark:bg-gray-800 p-4 rounded-xl border border-gray-200 dark:border-gray-700 flex items-center gap-4">
    <div
      className={`p-3 rounded-full`}
      style={{ backgroundColor: `${color}1A`, color }}
    >
      {icon}
    </div>
    <div>
      <p className="text-gray-500 dark:text-gray-400 text-xs font-medium">{title}</p>
      <p className="text-title-page-color-100 dark:text-white text-2xl font-bold">{value}</p>
    </div>
  </div>
);